import React from 'react';
import { useStyles } from './styles';
import classNames from 'classnames';

const ConfirmBar = ({ disabled, resetOnClick, onOkClick }) => {
  const classes = useStyles();
  return (
    <div className={classes.bottomBox}>
      <button
        className={classNames(classes.resetBtn, { [classes.disabledbtn]: disabled })}
        onClick={resetOnClick}
        disabled={disabled}
      >
        Reset
      </button>
      <button className={classes.okbtn} onClick={onOkClick}>
        OK
      </button>
    </div>
  );
};

export default ConfirmBar;
